import { render, staticRenderFns } from "./VideoProjects.vue?vue&type=template&id=24b2fb0b&scoped=true&"
import script from "./VideoProjects.vue?vue&type=script&lang=js&"
export * from "./VideoProjects.vue?vue&type=script&lang=js&"
import style0 from "./VideoProjects.vue?vue&type=style&index=0&id=24b2fb0b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b2fb0b",
  null
  
)

export default component.exports